import { useEffect } from 'react';
import { siteOrigin } from '../../lib/schiek-content';

type SeoProps = {
  title: string;
  description: string;
  path?: string;
};

function setMeta(selector: string, attr: 'content' | 'href', value: string) {
  let element = document.head.querySelector(selector) as HTMLMetaElement | HTMLLinkElement | null;

  if (!element) {
    element = selector.startsWith('link')
      ? document.createElement('link')
      : document.createElement('meta');

    if (selector.includes('rel="canonical"')) {
      (element as HTMLLinkElement).rel = 'canonical';
    }

    const nameMatch = selector.match(/name="([^"]+)"/);
    if (nameMatch) {
      (element as HTMLMetaElement).name = nameMatch[1];
    }

    const propertyMatch = selector.match(/property="([^"]+)"/);
    if (propertyMatch) {
      (element as HTMLMetaElement).setAttribute('property', propertyMatch[1]);
    }

    document.head.appendChild(element);
  }

  element.setAttribute(attr, value);
}

export default function Seo({ title, description, path = '/' }: SeoProps) {
  useEffect(() => {
    const normalizedPath = path === '/' ? '/' : `/${path.replace(/^\/|\/$/g, '')}/`;
    const canonical = `${siteOrigin}${normalizedPath === '/' ? '/' : normalizedPath}`;

    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('link[rel="canonical"]', 'href', canonical);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
  }, [description, path, title]);

  return null;
}
